// extracted by mini-css-extract-plugin
module.exports = {"clubEmailRecipients":"ClubEmailRecipientsList_clubEmailRecipients__17Fif"};